<template>
    <div>
        <div class="flex flex-wrap flex-col md:flex-row">
            <div class="w-full md:w-1/2">
                <h1 class="mt-2 mb-4 md:mb-0 font-sans-bold">Past Events</h1>
            </div>
        </div>
        <div class="responsive-table">
            <table class="w-full">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Festival</th>
                        <th>Start Date</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tr v-if="this.isSearching && this.searchedEvents.length < 1">
                    <td colspan="5" class="text-center font-bold">No search results</td>
                </tr>
                <event-item
                    v-else
                    v-for="event in pastEvents"
                    :key="event.id"
                    :event="event"></event-item>
            </table>
        </div>

        <div class="flex mt-8">
            <div class="w-1/2">
            <button class="mt-2"
                @click.stop.prevent="previous"
                :disabled="currentPage === 1"
                :class="{'opacity-50 cursor-not-allowed': currentPage === 1}">&lt;&lt; Previous</button>
            </div>

            <div class="w-1/2 text-right">
            <button class="mt-2"
                @click.stop.prevent="next"
                :disabled="currentPage === totalPages"
                :class="{'opacity-50 cursor-not-allowed': currentPage === totalPages}">Next &gt;&gt;</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import EventItem from './EventItem.vue'
    import moment from 'moment'

    export default {
        name: 'PastEvents',
        title: 'Past Events',
        components: {
            'event-item': EventItem
        },
        data: () => ({
            keyword: '',
            pastEvents: [],
            searchedEvents: {},
            isSearching: false,
            searchMeta: {},
            pagination: {
                current_page: 1
            }
        }),
        computed: {
            ...mapGetters({
                user: 'user'
            }),
            totalRecords() {
                return Object.keys(this.events).length
            },
            currentPage() {
                return this.pagination.current_page
            },
            totalPages() {
                return this.pagination.last_page
            }
        },
        watch: {
            user() {
                this.getPastEvents()
            },
            events(events) {
                this.setPastEvents()
            }
        },
        methods: {
            getPastEvents(page) {

                page = (page) ? page : this.pagination.current_page

                axios.get(laroute.route('api.events.past', {page: page }))
                    .then((response) => {
                        this.pastEvents = response.data.data
                        this.pagination = response.data.meta
                    })
            },
            previous() {
                var page = this.currentPage - 1
                this.getPastEvents(page)
                window.scrollTo(0, 0);
            },
            next() {
                var page = this.currentPage + 1
                this.getPastEvents(page)
                window.scrollTo(0, 0);
            }
        },
        mounted() {
            this.getPastEvents()
        }
    }
</script>
